export class CreativeFilterModel {
    constructor(
        public name: string = '',
        public publisherIds: Array<number>) {
    }
}


// WEBPACK FOOTER //
// ./src/app/creatives/creative-filter.model.ts